// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ContentWrapper } from "@insite/content-library/Widgets/Basic/RichContent";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { footerContainerStyles } from "@vanmeter/Overrides/Widgets/Footer/FooterContainer";
import { fontConfig } from "@vanmeter/XDL/constants";
import { color, getSystemColor, layoutContainer, xScreen } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.mainContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        padding-bottom: 16px;
        ${layoutContainer}
    `,
};

footerContainerStyles.topSection = {
    css: css`
        padding-top: 24px;
    `,
};

footerContainerStyles.middleSection = {
    css: css`
        padding-top: 32px;
        padding-bottom: 32px;
        border-bottom: 1px solid ${color("common.ui10")};
        margin: 0 0 32px;
        display: grid;
        grid-template-columns: minmax(0, 430px) repeat(4, 1fr);
        gap: 32px 22px;
        ${({ isAuthenticated }: any) =>
            !isAuthenticated &&
            `padding-top:50px;
            margin-top: 24px;
            border-top: 1px solid ${getSystemColor("common.ui10")};`}
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
            gap: 32px;
        }
    `,
};

footerContainerStyles.leftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;
    `,
};

footerContainerStyles.logoMessageSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
        ${ContentWrapper} {
            font-size: ${fontConfig.xSmall.size}px;
            line-height: ${fontConfig.xSmall.lineHeight};
            color: ${color("common.white")};
        }
        .wrapper:has(.home-page-link) {
            height: auto;
            .home-page-link {
                width: 200px;
                img {
                    aspect-ratio: 2.98;
                }
            }
        }
    `,
};

footerContainerStyles.mobileDownloadSection = {
    css: css`
        .img-wrapper {
            display: flex;
            ${TypographyStyle} {
                display: flex;
            }
        }
    `,
};

footerContainerStyles.linklistWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 32px;

        ${xScreen("lte", "md")} {
            flex-direction: row;
            gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            gap: 24px;
        }
    `,
};

footerContainerStyles.bottomSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
};

footerContainerStyles.socialImageLinksSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;

        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 32px;
            .list-wrapper {
                align-items: start;
            }
            .links-wrapper {
                flex-wrap: wrap;
                gap: 16px 32px;
            }
        }
    `,
};

footerContainerStyles.copyRightTermOfServiceSection = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 16px;
        & > div {
            display: flex;
        }
        .link-list {
            width: 100%;
        }
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 16px;
            .list-wrapper {
                align-items: start;
            }
            .links-wrapper {
                flex-wrap: wrap;
                gap: 8px 24px;
            }
        }
    `,
};
